<template>
  <div v-if="show" class="edit-crud-modal-overlay" @click.self="$emit('cancelar')" role="dialog" aria-modal="true">
    <div class="edit-crud-modal">
      <h4>{{ isEdit ? $t('editar') + ' ' + entityName : $t('añadir') + ' ' + entityName }}</h4>
      <form @submit.prevent="onSave">
        <input
          v-if="showCodigo"
          v-model="localItem.codigo"
          :placeholder="$t('codigo')"
          required
          maxlength="20"
        />
        <input
          v-model="localItem.nombre"
          :placeholder="$t('nombre')"
          required
          autofocus
        />
        <select
          v-if="showUsuario"
          v-model="localItem.id_user_notification"
        >
          <option value="">{{ $t('selecciona_usuario') }}</option>
          <option
            v-for="usuario in usuarios"
            :key="usuario.id"
            :value="usuario.id"
          >
            {{ usuario.nombre_completo }}
          </option>
        </select>
        <div class="edit-crud-modal-actions">
          <button type="submit" class="btn btn-success" :disabled="!canSave">{{ $t('guardar') }}</button>
          <button type="button" class="btn btn-secondary" @click="$emit('cancelar')">{{ $t('cancelar') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditCrudModal',
  props: {
    show: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    entityName: { type: String, default: 'categoría' },
    item: { type: Object, default: () => ({ codigo: '', nombre: '', id_user_notification: '' }) },
    showCodigo: { type: Boolean, default: false },
    showUsuario: { type: Boolean, default: false },
    usuarios: { type: Array, default: () => [] }
  },
  data() {
    return {
      localItem: { ...this.item }
    };
  },
  watch: {
    item: {
      handler(newVal) {
        this.localItem = { ...newVal };
      },
      deep: true
    },
    show(val) {
      if (val) this.localItem = { ...this.item };
    }
  },
  computed: {
    canSave() {
      return !!(this.localItem && String(this.localItem.nombre || '').trim());
    }
  },
  methods: {
    onSave() {
      if (!this.canSave) return;
      this.$emit('guardar', { ...this.localItem });
    }
  }
};
</script>

<style scoped>
.edit-crud-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}
.edit-crud-modal {
  background: #fff;
  border-radius: 12px;
  padding: 2rem 2.5rem;
  min-width: 320px;
  max-width: 95vw;
  box-shadow: 0 2px 12px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.edit-crud-modal h4 {
  margin: 0 0 0.5rem 0;
  font-size: 1.2rem;
  color: #99172A;
  font-weight: bold;
  text-align: center;
}
.edit-crud-modal input,
.edit-crud-modal select {
  width: 100%;
  padding: 8px 10px;
  border: 1.5px solid #ced4da;
  border-radius: 5px;
  font-size: 1rem;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.edit-crud-modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}
.btn {
  padding: 8px 18px;
  border-radius: 5px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.2s, color 0.2s;
}
.btn-success {
  background: #99172A;
  color: #fff;
}
.btn-success:hover {
  background: #7A1222;
}
.btn-secondary {
  background: #f8f9fa;
  color: #99172A;
  border: 1.5px solid #99172A;
}
.btn-secondary:hover {
  background: #e3e3e3;
  color: #7A1222;
}
</style>
